import { render, staticRenderFns } from "./solution.vue?vue&type=template&id=2d3fc8d6&scoped=true&"
import script from "./solution.vue?vue&type=script&lang=js&"
export * from "./solution.vue?vue&type=script&lang=js&"
import style0 from "./solution.vue?vue&type=style&index=0&id=2d3fc8d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3fc8d6",
  null
  
)

export default component.exports